// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"427":"a4c7892a","580":"25e062d8"}[chunkId] + ".chunk.css";
};